module.exports = __webpack_public_path__ + "img/vision-1.610510a5.svg";